import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlayAnimationHTMLDoc3DPlayers from './PlayAnimationHTMLDoc3DPlayers.tsx';
import type { Frame } from './DialogPlayBuilder.tsx';
import { UISETTINGSINIT } from './BoardConstants.ts';

type PlayMeta = {
    title: string;
};

interface PropsDialogPlayAnimation {
    play: PlayMeta,
    isOpen: boolean,
    onClose: () => void,
    frames: Frame[],
    courtType: 'halfcourt' | 'fullcourt',
    autoDownload?: boolean,
    use3DPlayers?: boolean,
    nativeApp?: boolean,
    courtColors?: {
        lineColor?: string;
        paintAreaColor?: string | null;
        paintAreaUseWoodPattern?: boolean;
        midRangeColor?: string | null;
        midRangeUseWoodPattern?: boolean;
        outOfBoundsColor?: string | null;
        outOfBoundsUseWoodPattern?: boolean;
    },
}

export default function DialogPlayAnimation({
    play,
    isOpen,
    onClose,
    frames,
    courtType,
    autoDownload,
    use3DPlayers = true,
    nativeApp = false,
    courtColors,
}: PropsDialogPlayAnimation) {

    const [modalContentUrl, setModalContentUrl] = useState('');

    useEffect(() => {
        const resolvedCourtColors = courtColors ?? {
            lineColor: UISETTINGSINIT.courtLineColor,
            paintAreaColor: UISETTINGSINIT.courtPaintAreaColor,
            paintAreaUseWoodPattern: UISETTINGSINIT.courtPaintAreaUseWoodPattern,
            midRangeColor: UISETTINGSINIT.courtMidRangeColor,
            midRangeUseWoodPattern: UISETTINGSINIT.courtMidRangeUseWoodPattern,
            outOfBoundsColor: UISETTINGSINIT.courtOutOfBoundsColor,
            outOfBoundsUseWoodPattern: UISETTINGSINIT.courtOutOfBoundsUseWoodPattern,
        };
        const HTMLDoc = PlayAnimationHTMLDoc3DPlayers(
            frames,
            courtType,
            play,
            nativeApp,
            autoDownload,
            resolvedCourtColors
        );
        const blob = new Blob([HTMLDoc], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        setModalContentUrl(url);

        return () => {
            URL.revokeObjectURL(url);
        };
    }, [frames, courtType, play, nativeApp, autoDownload, courtColors, use3DPlayers]);

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="animation-modal-title"
            aria-describedby="animation-modal-description"
            PaperProps={{
                style: {
                    borderRadius: 16,
                    maxWidth: '600px',
                    maxHeight: '650px',
                    width: '99%',
                    height: '99%',
                    margin: 1
                },
            }}
        >

            <DialogTitle fontWeight={'bold'} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {play.title}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    edge="end"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ padding: '6px 12px', display: 'flex', flexDirection: 'column', gap: 1 }}>
                <iframe
                    src={modalContentUrl}
                    style={{ width: '100%', height: '100%', border: 'none', padding: '0', flex: 1 }} // Asegurar que el iframe no tenga padding
                    title="Animation"
                />
            </DialogContent>

        </Dialog >
    );
};
